import { render, staticRenderFns } from "./StudentViewRelations.vue?vue&type=template&id=28a1eba2&"
import script from "./StudentViewRelations.vue?vue&type=script&lang=js&"
export * from "./StudentViewRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports